import { CSSProperties, FC } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { deprecatedTones } from "@src/deprecatedDesignSystem/styles/deprecatedColors";
import AutoLayout from "@src/deprecatedDesignSystem/components/AutoLayout";
import DeprecatedIcon, {
  DeprecatedIconType,
} from "@src/deprecatedDesignSystem/components/DeprecatedIcon";
import Spacer from "@components/ui/Spacer";
import Text from "@ui/text";

type Props = {
  showBanner: boolean;
  text: string;
  backgroundColor?: CSSProperties["backgroundColor"];
  color?: CSSProperties["color"];
  iconType?: DeprecatedIconType;
  button?: JSX.Element;
  borderRadius?: CSSProperties["borderRadius"];
};

const AnimatedBanner: FC<Props> = (props) => {
  return (
    <AnimatePresence>
      <motion.div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          alignSelf: "stretch",
          position: "relative",
          overflow: "hidden",
        }}
        animate={props.showBanner ? "showBanner" : "hideBanner"}
        initial={"hideBanner"}
        variants={{
          showBanner: {
            height: 54,
            opacity: 1,
            transition: {
              delay: 0,
              duration: 0.3,
            },
          },
          hideBanner: {
            height: 0,
            opacity: 0,
            transition: {
              delay: 0,
              duration: 0.3,
            },
          },
        }}
      >
        <AutoLayout
          flex={1}
          alignSelf={"stretch"}
          alignmentVertical={"center"}
          alignmentHorizontal={"center"}
          style={{
            borderRadius: props.borderRadius ?? 16,
            backgroundColor: props.backgroundColor || deprecatedTones.blue2,
          }}
        >
          <AutoLayout
            flex={1}
            alignSelf={"stretch"}
            alignmentHorizontal={"center"}
            alignmentVertical={"center"}
          >
            <DeprecatedIcon
              type={props.iconType || "lock"}
              color={props.color || deprecatedTones.blue9}
            />
            <Spacer size={8} axis={"horizontal"} />
            <Text
              type={"P2"}
              fontWeight={"Bold"}
              color={props.color || deprecatedTones.blue9}
            >
              {props.text}
            </Text>
            {props.button && (
              <AutoLayout marginLeft={8}>{props.button}</AutoLayout>
            )}
          </AutoLayout>
        </AutoLayout>
      </motion.div>
    </AnimatePresence>
  );
};

export default AnimatedBanner;
